import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class UserPasswordChangeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'password',
			value => {
				return value.trim().match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(^.{12,}$)/);
			},
			'PASSWORDMINREQUIREMENTS'
		);

		return {
			fields: [
				{
					name: 'newPassword',
					label: 'LOGINFORM.NEWPASSWORD',
					rules: ['required', 'string', 'password'],
					type: 'password',
				},
				{
					name: 'confirmPassword',
					label: 'LOGINFORM.CONFIRMPASSWORD',
					rules: 'required|string|same:newPassword',
					type: 'password',
				},
			],
		};
	}
}
